export default __webpack_public_path__ + "static/media/RocketDAO-DD.199512c0.png";